import { get } from 'lodash';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import { useQuery } from '@apollo/client';
import ListItem from '@mui/material/ListItem';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import Button from '@mui/material/Button';
import RowSpacer from 'components/RowSpacer';
import CancelIcon from '@mui/icons-material/Close';
import Switch from '@mui/material/Switch';
import React, { useState, useEffect } from 'react';
import Card from 'components/Card';
import CardActions from 'components/Card/Actions';
import CardHeader from 'components/Card/Header';
import CardText from 'components/Card/Text';
import Dialog from 'components/Dialog';
import LoadBlur from 'components/LoadBlur';
import Typography from '@mui/material/Typography';
import ProfileSecuritySettings from './ProfileSecurity';
import ProfilePage from '../Page';
import apiGateway from '../../../lib/apiGateway';
import { GET_PERSON_INFO } from '../../../schema/apolloQueries/profileQueries';

const styles = {
  light: {
    padding: '5px 9px 0',
  },
  cardHeaderTile: {
    color: '#F48120',
  },
  listHeader: {
    color: '#FFFFFF',
  },
  listSubHeader: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '13px',
    lineHeight: '10px',
    opacity: 0.5,
    color: '#FFFFFF',
  },
  dialogBody: {
    textAlign: 'center',
  },
  cardHeadrTitle: {
    color: '#0076BB',
    padding: '0 22px 16px',
  },
  cardText: {
    color: '#000',
    paddingBottom: 24,
  },
  card: {
    padding: 2,
    overflow: 'auto',
    marginBottom: 10,
  },
  left: {
    width: '5%',
  },
  cardActions: {
    display: 'inline-flex',
    paddingBottom: 24,
  },
  button: {
    borderRadius: 15,
    backgroundColor: '#0076BB',
    color: '#FFFFFF',
  },
  buttonRed: {
    borderRadius: 15,
    backgroundColor: '#EF493E',
    color: '#FFFFFF',
  },
  buttonOrange: {
    borderRadius: 15,
    backgroundColor: '#F48120',
    color: '#FFFFFF',
  },
  cardLayout: {
    borderRadius: 15,
    backgroundColor: '#FFFFFF',
    textAlign: 'center',
    padding: '0px 15px',
  },
  chip: { fontWeight: '600' },
  error: {
    textAlign: 'center',
  },
  formCard: {
    position: 'relative',
  },
  iconButton: {
    padding: 0,
    width: null,
  },
  list: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  signOutButtonLabel: {
  },
};

const ProfileSettingsPage = () => {
  const [viewer, setViewer] = useState({});
  const { data } = useQuery(GET_PERSON_INFO);
  useEffect(() => {
    setViewer(data?.viewer);
  }, [data]);
  const [
    sendingAllNotificationTypes,
  ] = useState(false);
  const [verified, setVerified] = useState(true);
  const [unsubscribeFlag, setUnsubscribeFlag] = useState(
    // isUnsubscribe === 'unsubscribe',
  );
  const [subscribeFlag, setSubscribeFlag] = useState(false);
  const [subscribeLoading, setSubscribeLoading] = useState(false);
  const [userUnsubscribed, setUserUnsubscribed] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const firstName = viewer?.person?.personInfo?.first;
  const lastName = viewer?.person?.personInfo?.last;
  const birthdate = viewer?.person?.personInfo?.birthdate;
  const address = viewer?.person?.address;
  const gender = viewer?.person?.personInfo?.gender;
  const phone = viewer?.person?.phoneNumber;

  useEffect(() => {
    if (
      firstName
      && lastName
      && address
      && Object.keys(address).length > 0
      && phone
      && gender
      && birthdate
    ) {
      setVerified(true);
    }
  }, [firstName, lastName, address, phone, gender, birthdate]);

  const checkSubscriptionStatus = val => {
    apiGateway.getSubscriptionStatus(get(viewer, 'personInfo.email')).then(resp => {
      if (resp) {
        setUserUnsubscribed(true);
        if (!val) {
          setUnsubscribeFlag(false);
        }
      } else {
        setUserUnsubscribed(false);
        if (!val) {
          setUnsubscribeFlag(true);
        }
      }
    });
  };

  useEffect(() => {
    checkSubscriptionStatus(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewer?.personInfo?.email]);
  const deleteUnsubscription = () => {
    apiGateway
      .subscribeNotifications(get(viewer, 'personInfo.email'))
      .then(resp => {
        if (resp?.status === 201) {
          setUserUnsubscribed(false);
          setUnsubscribeFlag(false);
          setSubscribeFlag(false);
        } else {
          setUserUnsubscribed(true);
          setUnsubscribeFlag(false);
          setSubscribeFlag(true);
          setError(`Failed to subscribe, ${resp.err}`);
        }
      });
  };
  const unsubscribe = () => {
    setSubscribeLoading(true);
    const pb = {
      email: get(viewer, 'personInfo.email'),
      reason: 'COMPLAINT',
    };
    apiGateway
      .unsubscribeNotifications(pb)
      .then(resp => {
        if (resp?.status === 201) {
          setSubscribeLoading(false);
          setSuccess(true);
          setError('');
          checkSubscriptionStatus(true);
        } else {
          setSubscribeLoading(false);
          setSuccess(false);
          setError(`Failed to unsubscribe, ${resp.err}`);
        }
      })
      .catch(err => {
        setSubscribeLoading(false);
        setSuccess(false);
        setError(`Failed to unsubscribe ${err}`);
        // eslint-disable-next-line no-console
        console.error('Failed to unsubscribe ', err);
      });
  };

  return (
    <>
      {subscribeFlag && (
        <Dialog onRequestClose={() => { }} open bodyStyle={styles.dialogBody}>
          <Card style={styles.cardLayout} rounded>
            <LoadBlur loading={subscribeLoading}>
              <div style={styles.left}>
                <IconButton onClick={() => setSubscribeFlag(false)} size='large'>
                  <CancelIcon htmlColor='#0076BB' />
                </IconButton>
              </div>
              {error && <span style={{ color: 'red' }}>{error}</span>}
              {!success && (
                <CardText style={styles.cardText} noTopPadding>
                  <p>
                    Wahoo, great choice! Just confirming, by clicking &ldquo;Okay&rdquo; below you will be opted in to receive Ripple Street emails. Sound good?
                  </p>
                </CardText>
              )}
              <CardActions noTopPadding style={styles.cardActions}>
                {!success && (
                  <>
                    <Button
                      style={styles.buttonRed}
                      variant='contained'
                      onClick={() => setSubscribeFlag(false)}
                    >
                      CANCEL
                    </Button>
                    <RowSpacer />
                  </>
                )}
                <Button
                  style={styles.button}
                  variant='contained'
                  onClick={deleteUnsubscription}
                >
                  {!success ? 'OKAY' : 'OK'}
                </Button>
              </CardActions>
            </LoadBlur>
          </Card>
        </Dialog>
      )}
      {unsubscribeFlag && (
        <Dialog onRequestClose={() => { }} open bodyStyle={styles.dialogBody}>
          <Card style={styles.cardLayout} rounded>
            <LoadBlur loading={subscribeLoading}>
              <div style={styles.left}>
                <IconButton
                  onClick={() => {
                    setUnsubscribeFlag(false);
                    setSuccess(false);
                  }}
                  size='large'
                >
                  <CancelIcon style={{ color: '#0076BB' }} />
                </IconButton>
              </div>
              {error && <span style={{ color: 'red' }}>{error}</span>}
              <Typography style={styles.cardHeadrTitle} variant='h6'>
                {success ? 'Successfully unsubscribed!' : 'Unsubscribe from Ripple Street emails'}
              </Typography>
              {!success && (
                <CardText style={styles.cardText} noTopPadding>
                  <p>
                    If you don&apos;t want Ripple Street to send you emails.
                    Click the unsubscribe button below.
                  </p>
                  <p>
                    Please note that if you do unsubscribe you will not be
                    eligible for Ripple Street event selection until you
                    subscribe back (we have to be able to notify you if you
                    win!).
                  </p>
                </CardText>
              )}
              <CardActions noTopPadding style={styles.cardActions}>
                {!success && (
                  <>
                    <Button
                      style={styles.buttonRed}
                      variant='contained'
                      onClick={unsubscribe}
                    >
                      UNSUBSCRIBE
                    </Button>
                    <RowSpacer />
                  </>
                )}
                <Button
                  style={styles.button}
                  variant='contained'
                  onClick={() => {
                    setUnsubscribeFlag(false);
                    if (!success) {
                      setUserUnsubscribed(false);
                    } else {
                      setUserUnsubscribed(true);
                    }
                    setSuccess(false);
                  }}
                >
                  {!success ? 'KEEP ME IN!' : 'OK'}
                </Button>
              </CardActions>
            </LoadBlur>
          </Card>
        </Dialog>
      )}
      <ProfilePage title='Settings' viewer={viewer}>
        <Card style={styles.card}>
          <CardHeader title='Account' titleStyle={styles.cardHeaderTitle} />
          {viewer?.personInfo
            && <ProfileSecuritySettings viewer={viewer} verified={verified} />}
        </Card>
        <Card style={styles.card}>
          <LoadBlur loading={sendingAllNotificationTypes}>
            <CardHeader
              title='Manage Ripple Street Notifications'
              titleStyle={styles.cardHeaderTile}
            />
            <List style={styles.list}>
              <ListItem
                key='emailNotification'
                style={{ paddingBottom: 0 }}
              >
                <ListItemText
                  primary='Emails from Ripple Street'
                  primaryTypographyProps={{ style: styles.listHeader }}
                  secondary='Important Note: If this is left unchecked, you will not be
                eligible for event selection'
                  secondaryTypographyProps={{ style: styles.listSubHeader }}
                />
                <ListItemSecondaryAction>
                  <Switch
                    onChange={() => (userUnsubscribed
                      ? setSubscribeFlag(true)
                      : checkSubscriptionStatus())}
                    style={{ color: !userUnsubscribed ? '#F48120' : '#726D6D' }}
                    defaultChecked={!userUnsubscribed}
                    checked={!userUnsubscribed}
                  />
                </ListItemSecondaryAction>
              </ListItem>
            </List>
            <CardActions />
          </LoadBlur>
        </Card>
      </ProfilePage>
    </>
  );
};

export default ProfileSettingsPage;
